<template>
  <div class="uni-mmask">
    <div
      :style="{ top: offsetTop + 'px' }"
      class="uni-mmask"
      @click="hide"
      @touchmove.stop.prevent="moveHandle"
    />
    <div class="moreBack" :style="{bottom:'0px',paddingBottom: '0px'}">
        <div class="uni-mpopup">
            <div class="btn"
                v-for="(item,index) in list"
                :key="index"
                @click="clickPopup(item)"
            >
              <div class="item-more-button">
                <img :src="item.image"
                class="item-more-button-icon"
                alt="">
                <span class="item-more-button-label">{{item.name}}</span>
                <div class="itemmorereddot1"  v-if="item.tip.length>0">
                  <span class="item-more-red">{{item.tip}}</span>
                </div>
                <div class="itemmoreredpoint" v-if="item.redpoint.length>0">
                </div>
              </div>
            </div>
        </div>
        <div class="cancel-sp-btn"></div>
        <div class="cancel-m—btn" @click="cancelhide">取消</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'myPopup',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      // top - 顶部， middle - 居中, bottom - 底部
      default: 'middle',
    },
    mode: {
      type: String,
      default: 'insert',
    },
    msg: {
      type: String,
      default: '',
    },
    h5Top: {
      type: Boolean,
      default: false,
    },
    buttonMode: {
      type: String,
      default: 'bottom',
    },
    list: {
      type: Array,
      default: () => [],
    },
    tabSelected: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isIphoneX: false,
      offsetTop: 0,
    };
  },
  watch: {
    h5Top(newVal) {
      if (newVal) {
        this.offsetTop = 0;
      } else {
        this.offsetTop = 0;
      }
    },
  },
  created() {
    let offsetTop = 0;
    if (!this.h5Top) {
      offsetTop = 0;
    } else {
      offsetTop = 0;
    }
    this.offsetTop = offsetTop;
    this.isIphoneX = false;
  },
  methods: {
    cancelhide() {
      this.$emit('cancelPopup');
      this.hide();
    },
    hide() {
      this.$emit('hidePopup');
    },
    closeMask() {
      if (this.mode === 'insert') {
        this.$emit('hidePopup');
      }
    },
    moveHandle() {},
    clickPopup(item) {
      this.hide();
      this.$emit('clickPopup', item);
    },
  },
};
</script>
<style lang="less">
.uni-mmask {
  position: fixed;
  z-index: 99999999;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.0);
}
.moreBack{
  position: fixed;
  flex-direction: column;
  width: 100%;
  bottom: 0px;
  z-index: 99999999;
  background-color: #ffffff;
}
.uni-mpopup {
  // display: grid;
  // grid-template-columns: 25% 25% 25% 25%;
  // z-index: 999;
  // background-color: #ffffff;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-bottom: 60px;
}
.item-more-button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    position: relative;
  }

  .item-more-button-icon {
    width: 88px;
    height: 88px;
    border-radius: 50%;
    background: #f5f5f5;
    border: 8px solid #f5f5f5;
    margin-top: 60px;
  }

  .item-more-button-label {
    font-family: PingFangSC-Regular;
    font-size: 24px;
    color: #333333;
    text-align: center;
    line-height: 24px;
    margin-top: 20px;
  }
.itemmorereddot1 {
    background: #FF6435;
    position: absolute;
    border: 2px solid #fff;
    top: 30px;
    right: 20px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 0px;
    // letter-spacing: 0;
    padding: 4px 4px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .itemmoreredpoint{
    height: 10px;
    width: 10px;
    background: #ff4400;
    position: absolute;
    right: 60px;
    top: 62px;
    border-radius: 5px;
  }
  .item-more-red{
    max-width: 150px;
    line-height: 30px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    font-size: 22px;
    color: #ffffff;
  }
.btn {
  width: 25%;
  font-size: 30px;
  text-align: center;
  border-bottom: 0px solid #eeeeee;
}
.cancel-sp-btn {
  height: 12px;
  width: 100%;
  background: #f5f5f5;
}

.cancel-m—btn {
  line-height: 88px;
  width: 100%;
  height: 88px;
  font-size: 36px;
  text-align: center;
  background-color: #ffffff;
}
</style>
